import { mediaItems } from '@/mocks/anime';

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精彩视频专区
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            热门AMV、MAD剪辑与剧场版PV一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-accent-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-video overflow-hidden relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 right-3 px-2 py-0.5 bg-black/60 text-white text-xs rounded-md whitespace-nowrap">
                  {item.views} 次观看
                </div>
                <span className="absolute top-3 left-3 px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-950 mb-1.5 group-hover:text-accent-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}